import {
  coolGray30,
  coolGray60,
  cyan60,
  green60,
  magenta50,
  purple60,
  yellow30,
} from "@carbon/colors";

import { ThemeColors } from "src/theme/ThemeProvider";

import { elementCodes } from "../graph.utils";

const colaNodeStyle = (colors: ThemeColors) => ({
  label: "data(label)",
  "font-family": "IBM Plex Sans",
  "font-size": 14,
  "font-weight": "500",
  color: colors.text.primary,
  "text-valign": "bottom",
  "text-halign": "center",
  "text-margin-y": 5,
  width: 50,
  height: 50,
  "background-color": colors.background.index,
  "border-width": "1",
  "border-color": coolGray30,
});

export const colaStyles = (colors: ThemeColors) => [
  // Styling for case nodes
  {
    selector: 'node[type="case"]',
    style: {
      ...colaNodeStyle(colors),
      shape: "circle",
      "background-color": (elem) => {
        const getIcon = elem.data("icon");
        if (getIcon && getIcon()) {
          return colors.background.index;
        }
        return cyan60;
      },
      "background-image": (elem) => {
        const getIcon = elem.data("icon");
        return getIcon(cyan60);
      },
    },
  },
  // Styling for the alert case
  {
    selector: 'node[type="case-alert"]',
    style: {
      ...colaNodeStyle(colors),
      shape: "circle",
      "background-color": (elem) => {
        const getIcon = elem.data("icon");
        if (getIcon && getIcon()) {
          return colors.background.index;
        }
        return yellow30;
      },
      "background-image": (elem) => {
        const getIcon = elem.data("icon");
        return getIcon(yellow30);
      },
      width: 70,
      height: 70,
    },
  },
  // Styling for element nodes
  {
    selector: 'node[type="element"]',
    style: {
      ...colaNodeStyle(colors),
      shape: "circle",
    },
  },
  // Styling for identifier nodes
  {
    selector: 'node[type="identifier"]',
    style: {
      ...colaNodeStyle(colors),
      shape: "circle",
      width: 32,
      height: 32,
    },
  },
  // Styling for edges
  {
    selector: 'edge[type="edge-case"]',
    style: {
      width: 1,
      "target-arrow-shape": "triangle",
      "curve-style": "bezier",
      "line-color": coolGray60,
      "target-arrow-color": coolGray60,
    },
  },
  {
    selector: 'edge[type="edge-elem"]',
    style: {
      width: 1,
      "target-arrow-shape": "triangle",
      "curve-style": "bezier",
    },
  },

  // color by element type

  // Représentant Légal
  {
    selector: `node[type="element"][name=${elementCodes.LegalRepresentative}]`,
    style: {
      "background-color": (elem) => {
        const getIcon = elem.data("icon");
        if (getIcon && getIcon()) {
          return colors.background.index;
        }
        return green60;
      },
      "background-image": (elem) => {
        const getIcon = elem.data("icon");
        return getIcon(green60);
      },
    },
  },
  {
    selector: `edge[type="edge-elem"][element=${elementCodes.LegalRepresentative}]`,
    style: {},
  },
  {
    selector: `node[type="identifier"][element=${elementCodes.LegalRepresentative}]`,
    style: {
      "background-color": (elem) => {
        const getIcon = elem.data("icon");
        if (getIcon && getIcon()) {
          return colors.background.index;
        }
        return green60;
      },
      "background-image": (elem) => {
        const getIcon = elem.data("icon");
        return getIcon(green60);
      },
    },
  },
  // Expert comptable
  {
    selector: `node[type="element"][code="${elementCodes.Accountant}"]`,
    style: {
      "background-color": (elem) => {
        const getIcon = elem.data("icon");
        if (getIcon && getIcon()) {
          return colors.background.index;
        }
        return magenta50;
      },
      "background-image": (elem) => {
        const getIcon = elem.data("icon");
        return getIcon(magenta50);
      },
    },
  },
  {
    selector: `edge[type="edge-elem"][code="${elementCodes.Accountant}"]`,
    style: {},
  },
  {
    selector: `node[type="identifier"][element="${elementCodes.Accountant}"]`,
    style: {
      "background-color": (elem) => {
        const getIcon = elem.data("icon");
        if (getIcon && getIcon()) {
          return colors.background.index;
        }
        return magenta50;
      },
      "background-image": (elem) => {
        const getIcon = elem.data("icon");
        return getIcon(magenta50);
      },
    },
  },
  // Entreprise
  {
    selector: `node[type="element"][code="${elementCodes.Company}"]`,
    style: {
      "background-color": (elem) => {
        const getIcon = elem.data("icon");
        if (getIcon && getIcon()) {
          return colors.background.index;
        }
        return purple60;
      },
      "background-image": (elem) => {
        const getIcon = elem.data("icon");
        return getIcon(purple60);
      },
    },
  },
  {
    selector: `edge[type="edge-elem"][element="${elementCodes.Company}"]`,
    style: {},
  },
  {
    selector: `node[type="identifier"][element="${elementCodes.Company}"]`,
    style: {
      "background-color": (elem) => {
        const getIcon = elem.data("icon");
        if (getIcon && getIcon()) {
          return colors.background.index;
        }
        return magenta50;
      },
      "background-image": (elem) => {
        const getIcon = elem.data("icon");
        return getIcon(purple60);
      },
    },
  },
];
